module.exports = __webpack_public_path__ + "static/media/newlogo.b3da6b8b.png";